<style lang="stylus" scoped>
@import './cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}
</style>

<template>
  <div class="home-main">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>

    <div class="map-search">
      <div class="map-title">
        <el-row>
          <CardHeader/>
          <el-col :span="12">
            <div class="t-r">
              <el-date-picker
                :clearable="false"
                v-model="timeSection"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <el-button v-show="hideExport" style="margin-left:20px;" @click="exportDate">导出</el-button>
              <SearchBtn/>
            </div>
          </el-col>
        </el-row>
      </div>
      <map-data-table :areaList="areaList" v-if="areaList&&areaList.length>0"></map-data-table>
    </div>
    <div class="map-data">
      <div class="map-area">
        <home-map :city-data="cityData" :time="timeSection" :dataType="dataType" :title="title"></home-map>
      </div>
      <map-card :time="timeSection" :changeType="changeType" :dong="dong"></map-card>
    </div>
  </div>
</template>

<script>
import SearchBtn from '@/components/searchBtn'
import homeMap from './components/map.vue'
import mapDataTable from './components/mapDataTable.1.vue'
import mapCard from './components/mapCard.vue'
import CardHeader from './components/cardHeader.vue'

import http from '@/api/cardData'
import cityData from './map-data/get-city-value.js'
import Cookies from 'js-cookie'
import { hideExport } from '@/utils/tools'
export default {
  name: 'home',
  components: {
    homeMap,
    mapDataTable,
    mapCard,
    SearchBtn,
    CardHeader
  },
  data() {
    return {
      hideExport:hideExport,
      timeSection: [
        new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 1 * 24 * 3600 * 1000) * 1
      ],
      cityData: [],
      areaList: [], //省列表
      dataType: '6', //点击省份详情列表
      title: 0, //地图标题
      tab: 0,
      progressNum: 0, //进度条进度
      mark: false, //是否显示遮罩层
      dong: false //控制动画变量
    }
  },
  watch: {
    timeSection: function(value, oldValue) {
      this.initData()
      this.dong = !this.dong
    }
  },
  computed: {
    allTab: function() {
      return this.$store.state.app.tab
    },
    titleArr: function() {
      return this.$store.state.app.titleArr
    }
  },
  created() {
    this.initData()
  },
  methods: {
    exportDate() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      window.times = setInterval(function() {
        http[that.allTab].progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(window.times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      window.location.assign(
        http[that.allTab].exportDataCount({
          start: this.timeSection[0],
          end: this.timeSection[1],
          reqId
        })
      )
    },
    changeType({ num, title }) {
      this.dataType = num
      this.title = title
    },
    initData() {
      let that = this
      http[that.tab].timeChange().then(e => {
        let data = e.data
        that.areaList = data.areaList
      })
    }
  }
}
</script>
